import styled from '@emotion/styled'
import { Box, CssBaseline, Link, Paper } from '@mui/material'
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import DaiLogo from '@/components/DaiLogo'
import GlobalStyle from '@/components/GlobalStyle'
import useAuth from '@/hooks/useAuth'
import useLoggedInUser from '@/hooks/useLoggedInUser'
import useT from '@/i18n/useT'

const FULL_WIDTH_STEPS = ['select-plan']

const Root = styled.div`
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  width: 100%;
`

const ContentContainer = styled.div<{ isFullWidth: boolean }>`
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  max-width: ${props => (props.isFullWidth ? '1040px' : '520px')};
`

const AccountSetUpLayout: React.FC<{
  children?: React.ReactNode
}> = ({ children }) => {
  const location = useLocation()
  const { signOut } = useAuth()
  const searchParams = new URLSearchParams(location.search)
  const currentStep = searchParams.get('step') || ''
  const { user } = useLoggedInUser()
  const { t } = useT()
  // Only allow full width on select-plan step before successful payment
  const isFullWidth =
    FULL_WIDTH_STEPS.includes(currentStep) && !user?.activeSubscription

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <ContentContainer isFullWidth={isFullWidth}>
        <Box
          sx={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            p: 6,
            gap: 6,
          }}
        >
          <DaiLogo />
          <Paper sx={{ padding: 6, width: '100%' }}>
            {children}
            <Outlet />
          </Paper>
        </Box>
      </ContentContainer>
      <Box
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          display: 'flex',
          width: '100%',
          pr: 6,
          pb: 6,
        }}
      >
        <Link
          onClick={() => {
            signOut()
          }}
          sx={{ cursor: 'pointer' }}
        >
          {t('common.logout')}
        </Link>
      </Box>
    </Root>
  )
}

export default AccountSetUpLayout
